var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.621427 8.35202C4.74403 13.2648 7.43368 19.4268 8.01606 26.1867C8.10035 27.1294 8.89729 27.8498 9.83982 27.8498H16.154C17.2115 27.8498 18.062 26.9608 17.9931 25.9031C17.9624 25.4969 17.9318 25.0907 17.8935 24.6922C17.6023 21.8564 17.0352 19.1126 16.2153 16.4761C15.8015 15.1579 15.3341 13.8626 14.7977 12.6057C14.0007 10.7126 13.0659 8.89617 12.0084 7.15639C11.3034 5.99909 10.5448 4.88012 9.7402 3.79946C9.15016 3.01004 8.52181 2.24362 7.87813 1.50019C7.87813 1.50019 7.87047 1.49253 7.8628 1.48486C7.17315 0.687782 5.95476 0.66479 5.21146 1.40056L0.728706 5.88413C0.0543769 6.55858 0.00839874 7.62391 0.613763 8.35202H0.621427Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector-5.eed7c498d29ee9eb57dcb5e6824afe9f.svg";
export { ForwardRef as ReactComponent };